import { TypeformLogicJumpCondition } from '@/api/model/typeform/typeform-logic-jump-condition'
import { TypeformField } from '@/api/model/typeform/typeform-field'

export class TypeformLogicJumpFlattenedCondition {
    private constructor(
        readonly id: string,
        public op: string,
        public vars: Array<{ type: string, value: string }>,
        public flattenedOp: string,
    ) {}

    toCondition(): TypeformLogicJumpCondition {
        return new TypeformLogicJumpCondition(
            this.id,
            this.op,
            this.vars,
        )
    }

    static fromCondition(condition: TypeformLogicJumpCondition, flattenedOp: string): TypeformLogicJumpFlattenedCondition {
        return new TypeformLogicJumpFlattenedCondition(
            condition.id,
            condition.op,
            condition.vars as Array<{ type: string, value: string }>,
            flattenedOp,
        )
    }

    static getFieldType(field: TypeformField|null): string|null {
        if (!field) {
            return 'text'
        }

        const fieldTypes = {
            text: ['short_text', 'long_text', 'dropdown', 'email', 'website'],
            numeric: ['number', 'opinion_scale', 'rating'],
            date: ['date'],
            choice: ['multiple_choice', 'picture_choice', 'yes_no', 'legal'],
            file: ['file_upload'],
        }

        for (const fieldType of Object.keys(fieldTypes)) {
            if (fieldTypes[fieldType].includes(field.type)) {
                return fieldType
            }
        }

        return null
    }

    static getFieldOps(field: TypeformField|null): string[] {
        return this.getOps(this.getFieldType(field))
    }

    static getOps(fieldType: string): string[] {
        const ops = {
            text: ['equal', 'not_equal', 'begins_with', 'ends_with', 'contains', 'not_contains'],
            numeric: ['equal', 'not_equal', 'lower_than', 'lower_equal_than', 'greater_than', 'greater_equal_than'],
            date: ['on', 'not_on', 'earlier_than', 'earlier_than_or_on', 'later_than', 'later_than_or_on'],
            choice: ['is', 'is_not'],
            file: ['answered'],
        }

        if (fieldType in ops) {
            return ops[fieldType]
        }

        return []
    }
}
